import moment from "moment";
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  Layout,
  Row,
  Typography,
} from "antd";
import { useForm } from "antd/lib/form/Form";
import TextArea from "antd/lib/input/TextArea";

const { Header } = Layout;

const CustomRow = ({ label, value }) => {
  return (
    <Row>
      <Col span={8}>
        <Typography style={{ marginBottom: 4 }}>{label}</Typography>
      </Col>
      <Col span={16}>
        <Form.Item>
          <Input autoComplete="off" type="text" readOnly value={value} />
        </Form.Item>
      </Col>
    </Row>
  );
};

const CustomComment = ({ label, value }) => {
  return (
    <Layout.Content
      style={{
        backgroundColor: "#FDFDFD",
        marginTop: 5,
      }}
    >
      <Form.Item label={label}>
        <TextArea
          autoSize={{ minRows: 2, maxRows: 6 }}
          autoComplete="off"
          value={value}
          readOnly
        />
      </Form.Item>
    </Layout.Content>
  );
};

const LoanDetails = ({
  loanDetails,
  setHideLoanDrawer,
  drawerVisibility,
  setLoanDetails,
}) => {
  const [form] = useForm();

  console.log("loanDetails", loanDetails);

  const supervisorName =
    loanDetails[0]?.loanApplicationParticipantStatuses?.supervisorList
      ?.filter(
        (x) =>
          x?.approveRejectRemarks != null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.participantName);

  const supervisorDescription =
    loanDetails[0]?.loanApplicationParticipantStatuses?.supervisorList
      ?.filter(
        (x) =>
          x?.approveRejectRemarks !== null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.approveRejectRemarks);

  const accountantName =
    loanDetails[0]?.loanApplicationParticipantStatuses?.accountantList

      ?.filter(
        (x) =>
          x?.approveRejectRemarks != null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.participantName);

  const accountantDescription =
    loanDetails[0]?.loanApplicationParticipantStatuses?.accountantList

      ?.filter(
        (x) =>
          x?.approveRejectRemarks !== null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.approveRejectRemarks);

  const managementName =
    loanDetails[0]?.loanApplicationParticipantStatuses?.managementList
      ?.filter(
        (x) =>
          x?.approveRejectRemarks != null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.participantName);

  const managementDescription =
    loanDetails[0]?.loanApplicationParticipantStatuses?.managementList
      ?.filter(
        (x) =>
          x?.approveRejectRemarks !== null &&
          x?.approveRejectRemarks !== undefined
      )
      ?.map((x) => x?.approveRejectRemarks);

  return (
    <>
      <Drawer
        width={460}
        maskClosable={false}
        onClose={setHideLoanDrawer}
        visible={drawerVisibility}
        closable={false}
        footer={
          <Layout.Content
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={() => {
                setHideLoanDrawer(false);
              }}
            >
              Cancel
            </Button>
          </Layout.Content>
        }
      >
        <Header className="drawer__header">
          <Typography className="drawer__header--title">
            Loan Details
          </Typography>
        </Header>
        <Form layout="vertical" form={form}>
          <>
            <Layout.Content
              style={{
                backgroundColor: "#FAFAFA",
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 5,
              }}
            >
              <CustomRow
                label="Company Name"
                value={loanDetails[0]?.sisterCompanyDto?.name}
              />
              <CustomRow
                label="Loan Application Date"
                value={moment(loanDetails[0]?.creationTime).format(
                  "YYYY/MM/DD"
                )}
              />
              <CustomRow
                label="Requested Amount"
                value={loanDetails[0]?.requestedAmount}
              />
              <CustomRow
                label="Application Status"
                value={loanDetails[0]?.loanApplicationStatusDtos?.displayName}
              />
              <CustomRow
                label="Amount Approved"
                value={loanDetails[0]?.approvedAmount}
              />
              <CustomRow label="Reason" value={loanDetails[0]?.reason} />
              {loanDetails[0]?.loanApplicationStatusDtos?.displayName ===
                "Supervisor_Approved" && (
                <CustomComment
                  label={`Supervisor's Comment (${supervisorName})`}
                  value={supervisorDescription}
                />
              )}
              {loanDetails[0]?.loanApplicationStatusDtos?.displayName ===
                "Accountant_Approved" && (
                <>
                  <CustomComment
                    label={`Supervisor's Comment (${supervisorName})`}
                    value={supervisorDescription}
                  />
                  <CustomComment
                    label={`Accountant's Comment (${accountantName})`}
                    value={accountantDescription}
                  />
                </>
              )}
              {loanDetails[0]?.loanApplicationStatusDtos?.displayName ===
                "Approved" && (
                <>
                  <CustomComment
                    label={`Supervisor's Comment (${supervisorName})`}
                    value={supervisorDescription}
                  />
                  <CustomComment
                    label={`Accountant's Comment (${accountantName})`}
                    value={accountantDescription}
                  />
                  <CustomComment
                    label={`Management's Comment (${managementName})`}
                    value={managementDescription}
                  />
                </>
              )}
            </Layout.Content>
          </>
        </Form>
      </Drawer>
    </>
  );
};
export default LoanDetails;
